import React from 'react';
import './DataDisplay.css';

const abbreviations = {
  Celsius: ' C',
  Degrees: '°',
  Feet: ' FT',
  inHG: ' inHG',
  Inches: ' IN',
  Knots: ' KTS',
  Miles: ' MI',
  Percent: '%'
};

function DataDisplay(props) {
  let content;

  if(typeof props.data === 'object') {
    let value = typeof props.data.value === 'number' && props.label !== 'Altimeter'
      ? Math.round(props.data.value) : props.data.value;
    content = (
      <div className="awos-data">
        <div className="awos-data-value">{value}</div>
        <div className="awos-data-units">{abbreviate(props.data.units)}</div>
      </div>
    );
  } else {
    content = (
      <div className="awos-data">
        <div className="awos-data-value">{props.data !== '' ? props.data : 'None'}</div>
      </div>
    );
  }
    
  return (
    <div className="awos-data-container">
      <div className="label">{props.label}</div>
        {content}
    </div>
  );
}

function abbreviate(value) {
  return abbreviations[value] || value;
}

export default DataDisplay;


/** WEBPACK FOOTER **
 ** ./src/DataDisplay/DataDisplay.js
 **/